export const settingsSections = [
  { key: "roles", label: "User Roles", icon: "bi-shield-lock" },
  { key: "users", label: "System Users", icon: "bi-person-gear" },
  { key: "academic", label: "Academic Setup", icon: "bi-mortarboard" },
  { key: "schoolFinance", label: "School & Finance", icon: "bi-cash-coin" },
  { key: "assessment", label: "Assessment Setup", icon: "bi-clipboard-check" },
  { key: "timetable", label: "Timetable Setup", icon: "bi-calendar-week" },
  { key: "security", label: "Security", icon: "bi-shield-check" },
  { key: "notifications", label: "Notifications", icon: "bi-bell" },
];

export const upcomingSections = [];

export const systemUserTypes = [
  { value: "SUPER_ADMIN", label: "Super Admin" },
  { value: "ADMIN", label: "Admin" },
  { value: "HEADMASTER", label: "Head's Office" },
  { value: "LIBRARIAN", label: "Librarian" },
  { value: "ACCOUNTANT", label: "Accountant" },
  { value: "RECEPTIONIST", label: "Receptionist" },
  { value: "DISCIPLINE", label: "Disciplinary Officer" },
  { value: "SPORTS", label: "Sports Coordinator" },
];
